import { makeDataObjGenerator } from 'mocks/helpers'
import { PersonAPI, WatchlistAPI } from 'types/api/types'
import { createGqlResponseTransformer, createSerialTestObjectArray } from 'utils/test-utils'

export const defaultItem = {
  id: '00000000-0000-0000-0000-000000000000',
  ownerId: 'own-12345',
  name: 'watchlist mock name',
  personIds: [] as string[],
  persons: [] as PersonAPI[],
  watchlistStats: {
    minimumSinglesWorldTennisNumber: 12.12,
    maximumSinglesWorldTennisNumber: 12.12,
    meanSinglesWorldTennisNumber: 12.12,
    minimumDoublesWorldTennisNumber: 12.12,
    maximumDoublesWorldTennisNumber: 12.12,
    meanDoublesWorldTennisNumber: 12.12,
    __typename: 'WatchlistStats',
  },
  __typename: 'Watchlist',
} as WatchlistAPI

export const createWatchlist = makeDataObjGenerator(defaultItem)

const defaultWatchlists = createSerialTestObjectArray(
  5,
  { id: 'id', name: 'TestWatchlistName' },
  createWatchlist
)

const defaultData = {
  items: defaultWatchlists,
  totalItems: defaultWatchlists.length,
}

export const getWatchlists = createGqlResponseTransformer(
  'watchlists',
  'WatchlistList',
  defaultData
)
